import angular from 'angular';

import { PlatformLogoComponent } from './platform-logo.component';

const MODULE_NAME = 'app.global.dashboard-component-library.platform-logo';

angular.module(MODULE_NAME, ['core.filters']).component('esPlatformLogo', PlatformLogoComponent);

export default MODULE_NAME;
